export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";

export const MONTH_MAP = {
  Jan: "January",
  Feb: "February",
  Mar: "March",
  Apr: "April",
  May: "May",
  Jun: "June",
  Jul: "July",
  Aug: "August",
  Sep: "September",
  Oct: "October",
  Nov: "November",
  Dec: "December",
};

export const DATE_FORMAT = {
  DEFAULT: "MM/DD/YYYY",
  ISO_YYYYMMDD: "YYYY-MM-DD",
  DATE_TIME: "MM-DD-YYYY HH:mm:ss",
  DATE_TIME_SLASH_FORMAT: "MM/DD/YYYY HH:mm:ss",
  FULL_DATE_TIME: "MM/DD/YYYY, h:mm:ss A",
  TIME_ONLY: "h:mm:ss A",
  TIME_ONLY_WITHOUT_SECONDS: "hh:mm A",
  SHORT_TIME: "h:mm A",
  SHORT_DATE_TIME: "MM/DD/YY h:mm A",
};

export const INVALID_DATE = "Invalid date";
